// import React from 'react';
// import './promtlogincardStyle.css';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faTimes } from '@fortawesome/free-solid-svg-icons';

// const PromptLoginCard = ({ onClose }) => {
//     return (
//         <div className="loginprompt-card-container">
//             <div className="loginprompt-card-header">
             
//                 <button className="promt-close-button" onClick={onClose}>
//                         <FontAwesomeIcon icon={faTimes} />
//                     </button>
//             </div>
//             <div className="loginprompt-card-body">
//                 <p>To get this amazing Service <br /> Please Login First!</p>
//                 <button className="loginprompt-gologin-btn" onClick={() => window.location.href = '/login'}>Go Login</button>
//             </div>
//         </div>
//     );
// }

// export default PromptLoginCard;



import React, { useEffect } from "react";
import "./promtlogincardStyle.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faRightToBracket } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const PromptLoginCard = ({ onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Close on ESC
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains("loginprompt-backdrop")) onClose?.();
  };

  const handleGoLogin = () => {
    onClose?.();
    navigate("/login");
  };

  return (
    <div
      className="loginprompt-backdrop"
      onClick={handleBackdropClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="loginprompt-title"
    >
      <div className="loginprompt-card-container" role="document">
        <div className="loginprompt-card-header">
          <h3 id="loginprompt-title" className="loginprompt-title">
            {t("promptLogin.title")}
          </h3>
          <button
            className="promt-close-button"
            onClick={onClose}
            aria-label={t("promptLogin.close")}
            title={t("promptLogin.close")}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="loginprompt-card-body">
          <div className="loginprompt-illustration" aria-hidden="true">
            <div className="loginprompt-badge">
              <FontAwesomeIcon icon={faRightToBracket} />
            </div>
          </div>

          <p className="loginprompt-message">
            {t("promptLogin.messageLine1")}
            <br />
            {t("promptLogin.messageLine2")}
          </p>

          <button
            className="loginprompt-gologin-btn"
            onClick={handleGoLogin}
          >
            <FontAwesomeIcon icon={faRightToBracket} className="loginprompt-btnicon" />
            {t("promptLogin.goLogin")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromptLoginCard;
